module.exports = __webpack_public_path__ + "img/pin_take_away_red.e870bbf8.svg";